import React from 'react'
import { Link } from 'react-router-dom'
import useAsset from '../../../hooks/useAsset'

const SecretFooter: React.FC = () => {
  const logo = useAsset('/Tailtations-Secret-Logo.svg')

  return (
    <footer className="bg-secret-bg-secondary border-t border-secret-border-primary mt-auto pb-safe">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src={logo}
                alt="Tailtations SECRET"
                className="w-[140px] h-auto"
              />
            </div>
            <p className="text-sm text-secret-text-tertiary max-w-sm">
              Exclusive access to Tailtations popup locations and pre-orders.
              Enjoy the VIP experience.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-white">Quick Links</h3>
            <nav className="space-y-2">
              <Link 
                to="/events" 
                className="block text-sm text-secret-text-secondary hover:text-white transition-colors"
              >
                Upcoming Events
              </Link>
              <Link 
                to="/orders" 
                className="block text-sm text-secret-text-secondary hover:text-white transition-colors"
              >
                My Orders
              </Link>
              <Link 
                to="/profile" 
                className="block text-sm text-secret-text-secondary hover:text-white transition-colors"
              >
                Profile Settings
              </Link>
            </nav>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-white">Support</h3>
            <nav className="space-y-2">
              <a 
                href="mailto:secret@tailtations.com" 
                className="block text-sm text-secret-text-secondary hover:text-white transition-colors"
              >
                Contact Support
              </a>
              <a 
                href="https://tailtations.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-sm text-secret-text-secondary hover:text-white transition-colors"
              >
                Main Website
              </a>
            </nav>
          </div>
        </div>

        <div className="border-t border-secret-border-secondary mt-8 pt-6">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
            <p className="text-xs text-secret-text-tertiary">
              © 2025 Tailtations LLC - All rights reserved.
            </p>
            <p className="text-xs text-secret-text-tertiary">
              Powered by premium ingredients and exclusive access
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default SecretFooter